import { Component, ViewChild, AfterViewInit, OnInit, ChangeDetectorRef } from "@angular/core";
import { FormsModule } from '@angular/forms';
import { CommonModule } from '@angular/common';
import { CommonService, CrudComponent } from 'wire-frame';
import { HttpClient, HttpHeaders } from "@angular/common/http";

import { TagModule } from 'primeng/tag';
import { ToggleButtonModule } from 'primeng/togglebutton';
import { AutoCompleteModule } from "primeng/autocomplete";
import { DropdownModule } from 'primeng/dropdown';
import { ToolbarModule } from 'primeng/toolbar';
import { ToastModule } from 'primeng/toast';
import { ConfirmDialogModule } from 'primeng/confirmdialog';
import { ConfirmationService } from 'primeng/api';
import { EditorModule } from 'primeng/editor';

import { VoicetestService} from '../../../service/admin/voicetest';
import { AppointmentService } from '../../../service/admin/appointment.service';
import { ClinicService } from '../../../service/admin/clinic.service';
import { UserService } from '../../../service/admin/user.service';
import { PatientRegistrationService } from '../../../service/admin/patient-registration.service';

import { ButtonModule } from 'primeng/button';
import { TabViewModule } from 'primeng/tabview';
import { InputTextModule } from 'primeng/inputtext';
import { FileUploadModule } from 'primeng/fileupload';
import { InputTextareaModule } from 'primeng/inputtextarea';
import { AccordionModule } from 'primeng/accordion';
import { ScrollPanelModule } from 'primeng/scrollpanel';
import { FloatLabelModule } from 'primeng/floatlabel';
import { SidebarModule } from 'primeng/sidebar';

import { DialogModule } from 'primeng/dialog';
import { ToasterService } from '../../../service/common/toaster.service';
import { buildHourlyAppointmentWindow } from '../../../utils/clinic-date.util';

@Component({
  selector: 'app-patients',
  standalone: true,
  imports: [
        FormsModule,
    CommonModule,
    TagModule,
    ToggleButtonModule,
    DropdownModule,
    ToolbarModule,
    ToastModule,
    ConfirmDialogModule,
    EditorModule,
    ButtonModule,
    TabViewModule,
    AccordionModule,
    ScrollPanelModule,
    DialogModule,
    InputTextModule,
    FloatLabelModule,
    SidebarModule,
    AutoCompleteModule
  ],
  providers: [ConfirmationService, CommonService, VoicetestService, AppointmentService, ClinicService, UserService, PatientRegistrationService],
  templateUrl: './voicetest.component.html',
  styleUrl: './voicetest.component.scss'
})
export class VoicetestComponent {
  public checked: boolean = false;
  activeIndex: number = 0;
  pationtIndex: number = 0;
  historyTabIndex: number = 0;
  public isDirty: boolean = false; 
    displayHistory: boolean = false; 

    isReportDialogVisible: boolean = false;

    
  isPatientVisible: boolean = true;

  clinicId: number = 0; // Default clinic ID
  doctorId: number = 0; // Default clinic ID
  selectedDate: string = new Date().toISOString().slice(0, 10);

  public patientsList: any[] = [];
  public voicetestList: any[] = [];
  selectedPatient: any;
  public clinicsList = [];
  public cardList = [];
  public doctorsList = [];
  public appointmentsList = [];
  public editRecord = null;
  public queue: any[] = [];
  uploadsByDate: { date: Date, files: any[] }[] = [];
  selectedIndex: number | string = 'today';
  filteredRecords: any[] = [];
  accordionIndex: number | null = null;
  
  public pendingFiles: File[] = [];

  public patient: any = {
    
  id: 0,  // number: Unique ID
  full_name: '',  
  salutation: '',
  contact_number: '',  // string: Phone number
  age: 0,
  is_free: false,     // number: Age in years  // boolean: true = free visit
  card_id: 0,     // string: Courier-related info

  scanned_card: null as File | null, // File upload (can be null or File)

  summary: '', // string: Summary of the visit
  medicines: '', // string: Prescribed medicines
  // other patient fields...
  diagnosis_receipt: '',
  visit_date: new Date(),
  receipt_amount: '',
  // card_dues: '',
  group_dues: '',
  fees_this_visit: '',
  mode: '',
  cash: '',
  cheque: '',

//other 

  // Date of first visit
  first_visit:  new Date(), // Date of first visit

  under_dr: '', // string: Under doctor's care (optional)
  occupation: '', // string: Occupation (optional)
  referred_by: '', // string: Referred by (optional)
  referred_by_dr: '', // string: Referred by (optional)
  other_refferce: '', // string: Other referred by (optional)
  };

  public prescription: any = {
    appointment_id: 0,
    summary: '',
    medicines: '',
    chief_complaints: '',
    diagnosis: '',
    past_history: '',
    menstrual_history: '',
    obstetric_history: '',
    respiratory_system: '',
    cardiovascular_system: '',
    central_nervous_system: '',
    per_abdomen: '',
    family_history: {
      father: '',
      mother: '',
      other: ''
    },
    others: {
      nail: '',
      mentals: '',
      stool: '',
      urine: '',
      sleep: '',
      parsp: '',
      corn: '',
      mole: '',
      hair: '',
      spine: '',
      pallor: '',
      cyanosis: '',
      clubbing: '',
      icterus: '',
      thirst: '',
      craving: '',
      aversion: '',
      dreams: '',
      thermals: '',
      warts: '',
      lm: '',
      tongue: '',
    },
    personal_dues: 0,
    visit_fees: 0,
    received_cash: 0,
    received_online: 0,
    card_dues: 0,
  }

  public patientSelectedFromSearch = false;

  public closeFormEvent: boolean = false;
  public openDeletePopup: any = null;
  public activeMenu: string = 'personal';

  constructor(
    public common: CommonService,
    private toaster: ToasterService, private confirmationService: ConfirmationService,
    private voicetestService: VoicetestService,
    private appointmentService: AppointmentService,
    private clinicService: ClinicService,
    private userService: UserService,
    private http: HttpClient, 
    private cdr: ChangeDetectorRef,
    private patientRegistrationService: PatientRegistrationService,
  ) {
    this.common.breadCrum = {
      title: 'Visa Card Master',
      icon: 'user',
      list: ['Visa Card Master'],
    };
    this.common.setCrudTableHeaders([
        
    {
    title: 'Patient Name',
    val: 'patient_name',
    id: 'id',
    showColumn: true,
    filterColmn: true,
    order: 'asc',
    searchColumn: true,
    type: 'string',
    globalSearch: true,
  }]);
    this.common.setCrudActions([
      {
        title: '',
        icon: 'pi-pencil',
        classArr: 'me-2',
        tooltip: 'Update Patient',
      },
      { title: '', icon: 'pi-trash', tooltip: 'Delete Patient' }]);
  }
  
  ngOnInit() {
    // this.getPatients();
    this.loadQueue();
    this.getCards();
  }

  private getAuthHeaders() {
        const token = localStorage.getItem('jwtToken');
        return {
          headers: new HttpHeaders({
            'Authorization' : `Bearer ${token}`
          })
        }
      }

  getVoicetest() {
    this.voicetestService.getVoicetest().subscribe((res: any) => {
      this.voicetestList = res.data;
    })
  }

  closeForm() {
    this.clearForm();
    this.closeFormEvent = true;
    setTimeout(() => {
      this.closeFormEvent = false;
    }, 1);
  }
  
  clearForm() { 
    this.patient = {
      id: 0,  // number: Unique ID
      full_name: '',  
      salutation: '',
      contact_number: '',  // string: Phone number
      age: 0,
      is_free: false,     // number: Age in years  // boolean: true = free visit
      card_id: 0,     // string: Courier-related info

      scanned_card: null as File | null, // File upload (can be null or File)

      summary: '', // string: Summary of the visit
      medicines: '', // string: Prescribed medicines
      // other patient fields...
      diagnosis_receipt: '',
      visit_date: new Date(),
      receipt_amount: '',
      card_dues: '',
      group_dues: '',
      fees_this_visit: '',
      mode: '',
      cash: '',
      cheque: '',

    //other 

      // Date of first visit
      first_visit:  new Date(), // Date of first visit

      under_dr: '', // string: Under doctor's care (optional)
      occupation: '', // string: Occupation (optional)
      referred_by: '', // string: Referred by (optional)
      referred_by_dr: '', // string: Referred by (optional)
      other_refferce: '', // string: Other referred by (optional)
    };

    this.prescription = {
      appointment_id: 0,
      summary: '',
      medicines: '',
      chief_complaints: '',
      diagnosis: '',
      past_history: '',
      menstrual_history: '',
      obstetric_history: '',
      respiratory_system: '',
      cardiovascular_system: '',
      central_nervous_system: '',
      per_abdomen: '',
      family_history: {
        father: '',
        mother: '',
        other: ''
      },
      others: {
        nail: '',
        mentals: '',
        stool: '',
        urine: '',
        sleep: '',
        parsp: '',
        corn: '',
        mole: '',
        hair: '',
        spine: '',
        pallor: '',
        cyanosis: '',
        clubbing: '',
        icterus: '',
        thirst: '',
        craving: '',
        aversion: '',
        dreams: '',
        thermals: '',
        warts: '',
        lm: '',
        tongue: '',
      },
      personal_dues: 0,
      visit_fees: 0,
      received_cash: 0,
      received_online: 0,
      card_dues: 0,
    }
    
    // ✅ Reset history + reports
    this.filteredRecords = [];   // prescription history
    this.uploadsByDate = [];
  }

  processPatients() {
    if (this.patient?.id) {
      this.updatePatients();
    } else {
      this.addVoicetest();
    }
  }

  addVoicetest() {
    if (this.patientSelectedFromSearch) {
      this.saveAppointmentAndPrescription();
      this.patientSelectedFromSearch = false; // reset flag
    } else {
      this.savePrescriptionOnly();
    }
  }


  // savePrescriptionOnly() {
  //   this.voicetestService.addVoicetest(this.prescription).subscribe((res: any) => {
  //     if (res.success) {
  //       const prescription = res.data;

  //       // ✅ Upload reports if there are any files waiting
  //       if (this.pendingFiles && this.pendingFiles.length > 0) {
  //         const formData = new FormData();
  //         formData.append('patient_id', this.patient.patient_id.toString());
  //         formData.append('prescription_id', prescription.id.toString());
  //         this.pendingFiles.forEach((file: File) => {
  //           formData.append('files[]', file, file.name);
  //         });

  //         this.voicetestService.uploadReports(formData).subscribe({
  //           next: (uploadRes: any) => {
  //             if (uploadRes.success) {
  //               this.mergeReports(uploadRes.data); // merge into gallery
  //             }
  //           },
  //           error: (err) => console.error('Report upload failed:', err)
  //         });
  //       }

  //       this.toaster.success(res.message);
  //       this.getVoicetest();
        
  //       // Change appointment status to 'completed'
  //       if (this.prescription.appointment_id) {
  //         this.appointmentService.changeStatus(this.prescription.appointment_id, 'completed').subscribe({
  //           next: () => this.loadQueue(), // Optionally refresh the queue
  //           error: (err) => console.error('Error changing status:', err)
  //         });
  //       }

  //       this.clearForm();
  //       this.closeForm();

  //     } else {
  //       this.toaster.error(res.message);
  //     }
  //   });
  // }

  savePrescriptionOnly() {
    if (!this.patient.patient_id) {
      console.error('No patient selected!');
      this.toaster.error('Please select a patient first.');
      return;
    }

    this.voicetestService.addVoicetest(this.prescription).subscribe({
      next: (res: any) => {
        if (!res.success) {
          this.toaster.error(res.message);
          return;
        }

        const prescription = res.data;

        // ✅ Update the current prescription id after save
        this.prescription.id = prescription.id;

        // Upload reports if any
        if (this.pendingFiles && this.pendingFiles.length > 0) {
          const formData = new FormData();
          formData.append('patient_id', this.patient.patient_id.toString());
          formData.append('prescription_id', this.prescription.id.toString());

          this.pendingFiles.forEach((file: File) => {
            formData.append('files[]', file, file.name);
          });

          this.voicetestService.uploadReports(formData).subscribe({
            next: (uploadRes: any) => {
              if (uploadRes.success) {
                this.mergeReports(uploadRes.data); // Merge into gallery
                this.pendingFiles = []; // ✅ Clear pending files after successful upload
              } else {
                console.error('Report upload failed:', uploadRes.message);
              }
            },
            error: (err) => console.error('Report upload failed:', err)
          });
        }

        this.toaster.success(res.message);

        // Refresh voicetest and queue
        this.getVoicetest();
        if (this.prescription.appointment_id) {
          this.appointmentService.changeStatus(this.prescription.appointment_id, 'medicine').subscribe({
            next: () => this.loadQueue(),
            error: (err) => console.error('Error changing status:', err)
          });
        }

        // ✅ Clear forms only after everything is handled
        this.clearForm();
        this.closeForm();

      },
      error: (err) => {
        console.error('Error saving prescription:', err);
        this.toaster.error('Failed to save prescription.');
      }
    });
  }

  updatePatients() {
    this.voicetestService.updateVoicetest(this.patient).subscribe((res: any) => {
      if (res.data) {
        this.toaster.success(res.message);
        this.getVoicetest();
        this.closeForm();
      } else {
        this.toaster.error(res.message);
      }
    });
  }

  // deletePatients(item: any) {
  //   this.voicetestService.deleteVoicetest(item).subscribe((res: any) => {
  //     this.toaster.add({
  //       severity: 'success',
  //       summary: 'Success',
  //       detail: 'Visa Card deleted successfully',
  //     });

  //     this.getVoicetest();
  //     this.closeForm();
  //   })
  // }

  // deleteRecord(event: any) {
  //   if(event) {
  //     this.deletePatients(event);
  //   }
  // }

  handleEvent(event: any) {
    // console.log(event);
    if(event.action.tooltip == "Update Patient") {
      this.editRecord = event.data;
      this.patient = event.data;
      setTimeout(() => {
        this.editRecord = null;
      }, 1);
    } else if(event.action.tooltip == "Delete Patient") {
      this.editRecord = event.data;
      this.delRecPopupOpen({title: this.editRecord?.['first_name  '], obj: this.editRecord});
    }
  }

  delRecPopupOpen(item: any) {
    this.openDeletePopup = item;
    setTimeout(() => {
      this.openDeletePopup = null;
    }, 1);
  }

  onCardUpload(event: any) {
  const file = event.target.files[0];
  this.patient.scanned_card = file ?? null;
}

onPrintReceipt() {
  console.log('Printing receipt...');
}


onShowReceiptHistory() {
  console.log('Showing receipt history...');
}

onShowOutstandingAll() {
  console.log('Showing all outstanding balances...');
}

  markDirty() {
    this.isDirty = true;
  }

  // Reset dirty state after saving/updating
  resetDirty() {
    this.isDirty = false;
  }

   patientHistory: any[] = [
    { date: '2025-08-01', summary: 'Follow-up checkup, BP stable' },
    { date: '2025-08-10', summary: 'Blood test results normal' },
    { date: '2025-08-15', summary: 'Prescription updated: Vitamin D' }
  ];
  
   openPoPopup() {
    this.displayHistory = true;
  }

  closePoPopup() {
    this.displayHistory = false;
  }

  
  // Method to close Patient section
  closePatient() {
    this.isPatientVisible = false;
  }

  // Method to reopen Patient section
  openPatient() {
    this.isPatientVisible = true;
  }

  
openReports(date: string) {
  this.selectedDate = date;
  this.isReportDialogVisible = true;
}

  searchPatients(event: any) {
    const query = event.query;
    this.http.get<any>('https://clinic.tantrata.com/api/patient/search', { params: { q: query }, ...this.getAuthHeaders()})
      .subscribe(res => {
        if (!res.data || res.data.length === 0) {
          this.patientsList = [];
          this.toaster.add({
            severity: 'info',
            summary: 'Info',
            detail: `No patients found for "${query}".`
          });
        } else {
          this.patientsList = res.data.map((p: any) => ({
            ...p,
            full_name: `${p.full_name} (${p.patient_number})`
          }));
        }
        // Stop spinner and update view
        this.cdr.detectChanges();
      }, error => {
        this.patientsList = [];
        this.toaster.info('No patients found.', 'Info');
        this.cdr.detectChanges();
      });
  }

  onPatientSelect(event: any) {
  // event.value is the selected patient object
    this.patient.patient_id = event.value.id || event.value.patient_id;
    // Optionally, store the whole patient object if needed
    this.selectedPatient = event.value;
    console.log('Selected patient_id:', this.patient.patient_id);
    this.patientSelectedFromSearch = true;
    this.isPatientVisible = false;

    // 1. Fetch patient info
    this.patientRegistrationService.getSinglePatient(this.patient.patient_id).subscribe((res: any) => {
      if (res.success) {
        const patient = res.data;
        this.patient.full_name = patient.full_name || '';
        this.patient.salutation = patient.salutation || '';
        this.patient.contact_number = patient.contact_number || '';
        this.patient.age = patient.age || '';
        this.patient.occupation = patient.occupation || '';
        this.patient.referred_by = patient.referred_by || '';
        this.patient.referred_by_dr = patient.referred_by_dr || '';
        this.patient.is_free = patient.is_free || false;
        this.patient.card_id = patient.card_id;
      }
    });

    // Fetch latest prescription for this patient
    // this.voicetestService.getLatestPrescription(this.patient.patient_id).subscribe((res: any) => {
    //   if (res.success && res.data) {
    //     const prescription = res.data;

    //     // Prefill prescription form
    //     this.prescription = {
    //       ...this.prescription,   // keep any default values
    //       summary: prescription.summary || '',
    //       chief_complaints: prescription.chief_complaints || '',
    //       medicines: prescription.medicines || '',
    //       diagnosis: prescription.diagnosis || '',
    //       menstrual_history: prescription.menstrual_history || '',
    //       obstetric_history: prescription.obstetric_history || '',
    //       central_nervous_system: prescription.central_nervous_system || '',
    //       cardiovascular_system: prescription.cardiovascular_system || '',
    //       respiratory_system: prescription.respiratory_system || '',
    //       per_abdomen: prescription.per_abdomen || '',
    //       family_history: prescription.family_history || { father: '', mother: '', other: '' },
    //       past_history: prescription.past_history || '',
    //       others: prescription.others || {
    //         nail: '',
    //         mentals: '',
    //         stool: '',
    //         urine: '',
    //         sleep: '',
    //         parsp: '',
    //         corn: '',
    //         mole: '',
    //         hair: '',
    //         spine: '',
    //         pallor: '',
    //         cyanosis: '',
    //         clubbing: '',
    //         icterus: '',
    //         thirst: '',
    //         craving: '',
    //         aversion: '',
    //         dreams: '',
    //         thermals: '',
    //         warts: '',
    //         lm: '',
    //         tongue: '',
    //       },
    //       personal_dues: prescription.personal_dues || 0,
    //       // visit_fees: prescription.visit_fees || 0,
    //       // received_cash: prescription.received_cash || 0,
    //       // received_online: prescription.received_online || 0
    //     };
    //   } else {
    //     // No previous prescription → clear form
    //     this.prescription = {
    //       summary: '',
    //       chief_complaints: '',
    //       medicines: '',
    //       diagnosis: '',
    //       menstrual_history: '',
    //       obstetric_history: '',
    //       central_nervous_system: '',
    //       cardiovascular_system: '',
    //       respiratory_system: '',
    //       per_abdomen: '',
    //       family_history: '',
    //       others: '',
    //       personal_dues: 0,
    //       visit_fees: 0,
    //       received_cash: 0,
    //       received_online: 0    
    //     };
    //   }
    // });

    // 2. Fetch ALL voicetest for history
    this.voicetestService.getVoicetestByPatientId(this.patient.patient_id).subscribe((res: any) => {
      if (res.success && res.data) {
        this.filteredRecords = res.data; // history tab
        console.log('Prescription history:', this.filteredRecords);

        // ✅ Calculate personal dues
        this.prescription.personal_dues = this.calculatePersonalDues(
          this.filteredRecords,
          this.prescription
        );

        // Calculate card dues dynamically
        this.prescription.card_dues = this.filteredRecords.length
          ? this.filteredRecords[0].card_dues || 0
          : 0; // use card_dues from API
      } else {
        this.filteredRecords = [];
        this.prescription.card_dues = 0;
      }
    });

    // ✅ Fetch reports
    this.voicetestService.getReportsByPatientId(this.patient.patient_id).subscribe((rRes: any) => {
      this.uploadsByDate = rRes.success ? rRes.data : [];
      console.log('Reports:', this.uploadsByDate);
    });

    // 3. (Optional) Clear prescription form since no active appointment
    // this.prescription = {
    //   summary: '',
    //   chief_complaints: '',
    //   medicines: '',
    //   diagnosis: '',
    //   menstrual_history: '',
    //   obstetric_history: '',
    //   central_nervous_system: '',
    //   cardiovascular_system: '',
    //   respiratory_system: '',
    //   per_abdomen: '',
    //   family_history: { father: '', mother: '', other: '' },
    //   past_history: '',
    //   others: {
    //     nail: '',
    //     mentals: '',
    //     stool: '',
    //     urine: '',
    //     sleep: '',
    //     parsp: '',
    //     corn: '',
    //     mole: '',
    //     hair: '',
    //     spine: '',
    //     pallor: '',
    //     cyanosis: '',
    //     clubbing: '',
    //     icterus: '',
    //     thirst: '',
    //     craving: '',
    //     aversion: '',
    //     dreams: '',
    //     thermals: '',
    //     warts: '',
    //     lm: '',
    //     tongue: '',
    //   },
    //   personal_dues: 0,
    //   card_dues: 0,
    // };
  }

  loadQueue() {
    const clinicId = sessionStorage.getItem('clinic_id') || '1';
    const doctorId = sessionStorage.getItem('doctor_id') || '1';

    // ✅ Check if clinic or doctor not selected
    if (!clinicId || !doctorId) {
      this.toaster.warn('Select the clinic and doctor', 'Missing Selection');
      // return; // stop execution
    }

    const date = this.selectedDate || new Date().toISOString().slice(0, 10);

    this.appointmentService.getQueue({
      clinic_id: clinicId,
      doctor_id: doctorId,
      date: date,
      // date: "2025-09-12",
      slot: 60
    }).subscribe((res: any) => {
      if (res.success) {
        const appointments = res.data.slots.flatMap((slot: any) =>
          slot.appointments.map((appt: any) => ({
            appointment_id: appt.id,
            patient_id: appt.patient_id,
            clinic_id: appt.clinic_id,
            doctor_id: appt.doctor_id,
            time: appt.start_time,
            status: appt.status
          }))
        );

        // Collect all patient IDs
        const patientIds = appointments.map((a: any) => a.patient_id);

        // Fetch all patient data in one request
        this.patientRegistrationService.getPatientsBatch(patientIds)
          .subscribe((patientRes: any) => {
            if (patientRes.success) {
              const patientsMap = new Map();
              patientRes.data.forEach((p: any) => patientsMap.set(p.id, p));

              // Map appointments to patients
              this.queue = appointments.map((appt: any) => {
                const patient = patientsMap.get(appt.patient_id);
                return {
                  name: `${patient.salutation} ${patient.full_name}`,
                  full_name: patient.full_name,
                  time: appt.time,
                  status: appt.status,
                  contact_number: patient.contact_number,
                  salutation: patient.salutation,
                  is_free: patient.is_free,
                  card_id: patient.card_id,
                  age: patient.age,
                  appointment_id: appt.appointment_id,
                  clinic_id: appt.clinic_id,
                  doctor_id: appt.doctor_id,
                  referred_by: patient.referred_by,
                  referred_by_dr: patient.referred_by_dr,
                  occupation: patient.occupation
                };
              });

              // Sort by time once
              this.queue.sort((a, b) => a.time.localeCompare(b.time));
              console.log('Loaded queue:', this.queue);
            }
          });
      }
    });
  }


  // loadQueue() {
  //   const date = this.selectedDate || new Date().toISOString().slice(0, 10);

  //   this.appointmentService.getQueue({clinic_id: 1, doctor_id: 1, date: "2025-09-12", slot: 60}).subscribe((res:any) => {
  //     if(res.success) {
  //       // this.queue = res.data.slots.flatMap((slot: any) => 
  //       //   slot.appointments.map((appt: any) => {
  //       //     const prescription = appt.patient.voicetest[0]; // might be undefined
  //       //     return {
  //       //       name: appt.patient.salutation + ' ' + appt.patient.full_name,
  //       //       full_name: appt.patient.full_name,
  //       //       time: appt.start_time,
  //       //       status: appt.status,
  //       //       contact_number: appt.patient.contact_number,
  //       //       salutation: appt.patient.salutation,
  //       //       is_free: appt.patient.is_free,
  //       //       card_id: appt.patient.card_id,
  //       //       age: appt.patient.age,
  //       //       appointment_id: appt.id,
  //       //       clinic_id: appt.clinic_id,
  //       //       doctor_id: appt.doctor_id,
  //       //       summary: prescription?.summary || '',
  //       //       chief_complaints: prescription?.chief_complaints || '',
  //       //       medicines: prescription?.medicines || '',
  //       //       diagnosis: prescription?.diagnosis || '',

  //       //       referred_by: appt.patient.referred_by,
  //       //       referred_by_dr: appt.patient.referred_by_dr,
  //       //       occupation: appt.patient.occupation
  //       //     };
  //       //   })
  //       // );

  //       const appointments = res.data.slots.flatMap((slot: any) =>
  //         slot.appointments.map((appt: any) => ({
  //           appointment_id: appt.id,
  //           patient_id: appt.patient_id,
  //           clinic_id: appt.clinic_id,
  //           doctor_id: appt.doctor_id,
  //           time: appt.start_time,
  //           status: appt.status
  //         }))
  //       );

  //       // Clear queue befoer filling.
  //       this.queue = [];

  //       // Fetch patient data for each appointment
  //       appointments.forEach((appt: any) => {
  //         this.patientRegistrationService.getSinglePatient(appt.patient_id).subscribe((patientRes: any) => {
  //           if (patientRes.success) {
  //             const patient = patientRes.data;

  //             this.queue.push({
  //               name: `${patient.salutation} ${patient.full_name}`,
  //               full_name: patient.full_name,
  //               time: appt.time,
  //               status: appt.status,
  //               contact_number: patient.contact_number,
  //               salutation: patient.salutation,
  //               is_free: patient.is_free,
  //               card_id: patient.card_id,
  //               age: patient.age,
  //               appointment_id: appt.appointment_id,
  //               clinic_id: appt.clinic_id,
  //               doctor_id: appt.doctor_id,
  //               referred_by: patient.referred_by,
  //               referred_by_dr: patient.referred_by_dr,
  //               occupation: patient.occupation
  //             });

  //             this.queue.sort((a: any, b: any) => a.time.localeCompare(b.time));
  //           }
  //         });
  //       });
        
  //       }
  //     });
  //     console.log('Loaded queue:', this.queue);
  // }

  // selectPatient(item: any) {
  //   this.appointmentService.changeStatus(item.appointment_id, 'in progress').subscribe({
  //     next: (res:any) => {
  //       if(res.success) {
  //         this.loadQueue(); // Refresh the queue to reflect status change
  //       };
  //     },
  //     error: (err) => {
  //       console.error('Error changing status:', err);
  //     }
  //   });

  //   this.patientRegistrationService.getCards().subscribe({
  //     next: (res: any) => {
  //       console.log('Card API response:', res);
  //       this.cardList = Array.isArray(res.data)
  //         ? res.data.map((card:any) => ({
  //             label: card.number,
  //             value: card.id
  //           }))
  //         : [];
  //     }
  //   });

  //   this.isPatientVisible = false;

  //   // populate the patient form fields
  //   // this.patient.card_no      = item.card_no || '';
  //   this.patient.full_name = item.full_name || '';
  //   this.patient.card_id = item.card_id || '';
  //   this.patient.salutation = item.salutation || '';
  //   this.patient.contact_number       = item.contact_number || '';
  //   this.patient.age     = item.age || '';
  //   this.patient.status1      = item.status || 'Checkup';
  //   this.patient.is_free      = item.is_free || false;
  //   this.patient.occupation = item.occupation || '';
  //   this.patient.referred_by = item.referred_by || '';
  //   this.patient.referred_by_dr = item.referred_by_dr || '';

  //   this.clinicId = item.clinic_id || 0;
  //   this.doctorId = item.doctor_id || 0;

  //   this.prescription.appointment_id     = item.appointment_id || '';
  //   this.prescription.summary = item.summary || '',
  //   this.prescription.chief_complaints = item.chief_complaints || '',
  //   this.prescription.medicines = item.medicines || '',
  //   this.prescription.diagnosis = item.diagnosis || ''
  // }

  selectPatient(item: any) {
    // 1. Change appointment status
    this.appointmentService.changeStatus(item.appointment_id, 'in progress').subscribe({
      next: (res: any) => {
        if (res.success) {
          this.loadQueue(); // Refresh the queue to reflect status change
        }
      },
      error: (err) => {
        console.error('Error changing status:', err);
      }
    });

    // 2. Load patient cards
    this.patientRegistrationService.getCards().subscribe({
      next: (res: any) => {
        console.log('Card API response:', res);
        this.cardList = Array.isArray(res.data)
          ? res.data.map((card: any) => ({
              label: card.number,
              value: card.id
            }))
          : [];
      }
    });

    // 3. Hide patient selector (queue popup)
    this.patientSelectedFromSearch = false;
    this.isPatientVisible = false;

    // 4. Fetch full appointment details (patient + voicetest)
    this.appointmentService.getAppointmentDetails(item.appointment_id).subscribe((res: any) => {
      if (res.success) {
        const appt = res.data;
        const patient = appt.patient;
        const prescription = patient.voicetest || {};
        // const prescription = patient.voicetest?.[0] || {};

        // Patient form
        this.patient = {
          patient_id: patient.id,
          full_name: patient.full_name || '',
          card_id: patient.card_id || '',
          salutation: patient.salutation || '',
          contact_number: patient.contact_number || '',
          age: patient.age || '',
          status1: appt.status || 'Checkup',
          is_free: patient.is_free || false,
          occupation: patient.occupation || '',
          referred_by: patient.referred_by || '',
          referred_by_dr: patient.referred_by_dr || ''
        };

        // Clinic/doctor ids
        this.clinicId = appt.clinic_id || 0;
        this.doctorId = appt.doctor_id || 0;

        // Active prescription form
        this.prescription = {
          id: prescription.id,
          appointment_id: appt.id,
          summary: prescription.summary || '',
          chief_complaints: prescription.chief_complaints || '',
          medicines: prescription.medicines || '',
          diagnosis: prescription.diagnosis || '',
          menstrual_history: prescription.menstrual_history || '',
          obstetric_history: prescription.obstetric_history || '',
          central_nervous_system: prescription.central_nervous_system || '',
          cardiovascular_system: prescription.cardiovascular_system || '',
          respiratory_system: prescription.respiratory_system || '',
          per_abdomen: prescription.per_abdomen || '',
          past_history: prescription.past_history || '',
          family_history: prescription.family_history || { father: '', mother: '', other: '' },
          others: prescription.others || {
            nail: '', mentals: '', stool: '', urine: '', sleep: '',
            parsp: '', corn: '', mole: '', hair: '', spine: '',
            pallor: '', cyanosis: '', clubbing: '', icterus: '',
            thirst: '', craving: '', aversion: '', dreams: '',
            thermals: '', warts: '', lm: '', tongue: ''
          },
          personal_dues: prescription.personal_dues || 0,
          visit_fees: prescription.visit_fees || 0,
          received_cash: prescription.received_cash || 0,
          received_online: prescription.received_online || 0,
          card_dues: prescription.card_dues || 0,
        };

        // 5. Load full history (same as search flow)
        this.voicetestService.getVoicetestByPatientId(patient.id).subscribe((res: any) => {
          this.filteredRecords = res.success ? res.data : [];
          // ✅ Calculate personal dues
          this.prescription.personal_dues = this.calculatePersonalDues(
            this.filteredRecords,
            this.prescription
          );
          // Calculate card dues dynamically
          this.prescription.card_dues = this.filteredRecords.length
            ? this.filteredRecords[0].card_dues || 0
            : 0; // use card_dues from API
        });

        //6. ✅ Fetch reports for this patient
        this.voicetestService.getReportsByPatientId(patient.id).subscribe((rRes: any) => {
          this.uploadsByDate = rRes.success ? rRes.data : [];
        });

      }
    });
  }


  getColorClass(status: string): string {
    switch (status) {
      case 'in progress': return 'bg-light-yellow';
      case 'completed': return 'bg-light-green';
      case 'scheduled': return 'bg-light-blue';
      case 'cancelled': return 'bg-light-red';
      default: return 'bg-light-yellow';
    }
  }

  getClinic() {
    this.clinicService.getClinic().subscribe({
      next: (res: any) => {
        this.clinicsList = Array.isArray(res.data)
          ? res.data.map((clinic:any) => ({
              label: clinic.name,
              value: clinic.id
            }))
          : [];
      },
      error: (err) => {
        console.error('Clinic API error:', err);
        this.clinicsList = [];
      }
    });
  }

  getDoctors() {
    this.userService.getDoctors().subscribe({
      next: (res: any) => {
        this.doctorsList = Array.isArray(res.data)
          ? res.data.map((doctor:any) => ({
              label: doctor.name,
              value: doctor.id
            }))
          : [];
      },
      error: (err) => {
        console.error('Doctor API error:', err);
        this.doctorsList = [];
      }
    });
  }

  getCards() {
    this.patientRegistrationService.getCards().subscribe({
      next: (res: any) => {
        console.log('Card API response:', res);
        this.cardList = Array.isArray(res.data)
          ? res.data.map((card:any) => ({
              label: card.number,
              value: card.id
            }))
          : [];
      },
      error: (err) => {
        console.error('Card API error:', err);
        this.cardList = [];
      }
    });
  }

  // onFileUpload(event: any) {
  //   const files = event.target.files;
  //   const today = new Date();

  //   let group = this.uploadsByDate.find(
  //     g => g.date.toDateString() === today.toDateString()
  //   );

  //   if (!group) {
  //     group = { date: today, files: [] };
  //     this.uploadsByDate.unshift(group); // latest date always at top
  //   }

  //   for (let file of files) {
  //     const fileObj = {
  //       name: file.name,
  //       type: file.type,
  //       url: URL.createObjectURL(file)
  //     };
  //     group.files.push(fileObj);
  //   }
  // }

  onFileUpload(event: any) {
    this.pendingFiles = Array.from(event.target.files);
  }

  // Merge new reports into gallery
  private mergeReports(newReports: any[]) {
    newReports.forEach(r => {
      const date = r.uploaded_at.split(' ')[0];
      let group = this.uploadsByDate.find(g => g.date === date);
      if (!group) {
        group = { date, files: [] };
        this.uploadsByDate.push(group);
      }
      group.files.push(r);
    });
  }

  openFile(file: any) {
    window.open(file.url, "_blank"); // opens in new tab
  }

  scrollToRecord(index: number) {
    const el = document.getElementById('record-' + index);
    if (el) {
      el.scrollIntoView({ behavior: 'smooth', block: 'start' });
    }
  }

  scrollToToday() {
    // Assuming latest record is at index 0 after reverse
    const el = document.getElementById('record-0');
    if (el) {
      el.scrollIntoView({ behavior: 'smooth', block: 'start' });
    }
  }

  createOnFlowAppointment(event: any) {
    const now = new Date();

    // Format Appointment Date as YYYY-MM-DD
    const appointmentDate = now.toISOString().slice(0, 10);

    const { start_time: startTime, end_time: endTime } = buildHourlyAppointmentWindow(now);

    // Create appointment payload
    const appointmentPayload = {
      clinic_id: 1,
      doctor_id: 1,
      // clinic_id: this.clinicId,
      // doctor_id: this.doctorId,
      patient_id: event.value.id || event.value.patient_id,
      appointment_date: appointmentDate,
      start_time: startTime,
      end_time: endTime,
      status: 'in progress',
      type: 'on_flow',
    };

    // Add appointment using service
    this.appointmentService.addAppointment(appointmentPayload).subscribe({
      next: (res: any) => {
        const appt = res.data;
        console.log('Appointment created:', res);
        this.toaster.success('Appointment Created successfully');

        this.appointmentService.getAppointmentDetails(appt.id).subscribe((res: any) => {
          if (res.success) {
            const appt = res.data;
            const patient = appt.patient;
            const prescription = patient.voicetest?.[0] || {};

            // Patient form fields
            this.patient.full_name = patient.full_name || '';
            this.patient.card_id = patient.card_id || '';
            this.patient.salutation = patient.salutation || '';
            this.patient.contact_number = patient.contact_number || '';
            this.patient.age = patient.age || '';
            this.patient.status = appt.status || 'Checkup';
            this.patient.is_free = patient.is_free || false;
            this.patient.occupation = patient.occupation || '';
            this.patient.referred_by = patient.referred_by || '';
            this.patient.referred_by_dr = patient.referred_by_dr || '';

            // Clinic/doctor ids
            this.clinicId = appt.clinic_id || 0;
            this.doctorId = appt.doctor_id || 0;

            // Prescription fields
            this.prescription.appointment_id = appt.id || '';
            this.prescription.summary = prescription.summary || '';
            this.prescription.chief_complaints = prescription.chief_complaints || '';
            this.prescription.medicines = prescription.medicines || '';
            this.prescription.diagnosis = prescription.diagnosis || '';
            this.prescription.menstrual_history = prescription.menstrual_history || '';
            this.prescription.obstetric_history = prescription.obstetric_history || '';
            this.prescription.central_nervous_system = prescription.central_nervous_system || '';
            this.prescription.cardiovascular_system = prescription.cardiovascular_system || '';
            this.prescription.respiratory_system = prescription.respiratory_system || '';
            this.prescription.per_abdomen = prescription.per_abdomen || '';
            this.prescription.family_history = prescription.family_history || '';
            this.prescription.others = prescription.others || '';
            // this.prescription.card_dues = prescription.card_dues || 0;
            // this.prescription.personal_dues = prescription.personal_dues || 0;
          }
        });

      },
      error: (err) => {
        console.error('Appointment creation error:', err);
        // Handle error (e.g., show error message)
        this.toaster.error('Failed to create appointment');
      }
    });
  }

  saveAppointmentAndPrescription() {
    const now = new Date();
    const appointmentDate = now.toISOString().slice(0, 10);
    const { start_time: startTime, end_time: endTime } = buildHourlyAppointmentWindow(now);

    const clinicId = sessionStorage.getItem('clinic_id');
    const doctorId = sessionStorage.getItem('doctor_id');

    // Appointment payload
    const appointmentPayload = {
      clinic_id: Number(clinicId) || 1,
      doctor_id: Number(doctorId) || 1,
      // clinic_id: this.clinicId,
      // doctor_id: this.doctorId,
      patient_id: this.patient.patient_id,
      appointment_date: appointmentDate,
      start_time: startTime,
      end_time: endTime,
      status: 'medicine',
      type: 'on_flow',
    };

    this.appointmentService.addAppointment(appointmentPayload).subscribe({
      next: (res: any) => {
        if (res.success) {
          const appt = res.data;

          // Now create prescription linked to this appointment
          const prescriptionPayload = {
            appointment_id: appt.id,
            summary: this.prescription.summary,
            chief_complaints: this.prescription.chief_complaints,
            medicines: this.prescription.medicines,
            diagnosis: this.prescription.diagnosis,
            menstrual_history: this.prescription.menstrual_history,
            obstetric_history: this.prescription.obstetric_history,
            central_nervous_system: this.prescription.central_nervous_system,
            cardiovascular_system: this.prescription.cardiovascular_system,
            respiratory_system: this.prescription.respiratory_system,
            per_abdomen: this.prescription.per_abdomen,
            past_history: this.prescription.past_history,
            family_history: this.prescription.family_history,
            others: this.prescription.others,
            personal_dues: this.prescription.personal_dues,
            visit_fees: this.prescription.visit_fees,
            received_cash: this.prescription.received_cash,
            received_online: this.prescription.received_online,
          };

          this.voicetestService.addVoicetest(prescriptionPayload).subscribe((presRes: any) => {
            if (presRes.success) {
              const prescription = presRes.data;

              // ✅ Upload reports if there are any files waiting
              if (this.pendingFiles && this.pendingFiles.length > 0) {
                const formData = new FormData();
                formData.append('patient_id', this.patient.patient_id.toString());
                formData.append('prescription_id', prescription.id.toString());
                this.pendingFiles.forEach((file: File) => {
                  formData.append('files[]', file, file.name);
                });

                this.voicetestService.uploadReports(formData).subscribe({
                  next: (uploadRes: any) => {
                    if (uploadRes.success) {
                      this.mergeReports(uploadRes.data); // merge into gallery
                    }
                  },
                  error: (err) => console.error('Report upload failed:', err)
                });
              }

              this.toaster.success('Appointment & Prescription saved successfully');

              this.clearForm();
            }
          });

          // this.clearForm();
        }
      },
      error: (err) => {
        console.error('Save error:', err);
        this.toaster.error('Failed to save appointment and prescription');
      }
    });
  }

  calculatePersonalDues(records: any[], current: any): number {
    let lastDue = 0;

    if (records && records.length > 0) {
      // Find the most recent prescription with dues > 0
      const last = records.find((r: any) => r.personal_dues && r.personal_dues >= 0);
      if (last) {
        lastDue = Number(last.personal_dues);
      }
    }

    const visitFees = current.visit_fees || 0;
    const receivedCash = current.received_cash || 0;
    const receivedOnline = current.received_online || 0;

    return (visitFees - (receivedCash + receivedOnline)) + lastDue;
  }
// ///////////////////////////////////////////////////////////////////////////////////////////////////////////////////




  // 🎤 Voice recognition controls
isRecording = false;
activeField = '';
recognition: any = null;

// 🎤 Start voice dictation
startDictation(fieldId: string) {
  if (this.isRecording) {
    alert('Please stop the current recording first.');
    return;
  }

  if (!('webkitSpeechRecognition' in window)) {
    alert('Speech recognition not supported in this browser.');
    return;
  }

  this.isRecording = true;
  this.activeField = fieldId;

  const recognition = new (window as any).webkitSpeechRecognition();
  this.recognition = recognition;

  recognition.continuous = true;
  recognition.interimResults = false;
  recognition.lang = 'en-US';
  recognition.start();

  recognition.onresult = (event: any) => {
    let transcript = event.results[event.resultIndex][0].transcript;

    // Replace common spoken symbols
    transcript = transcript
      .replace(/ colon/gi, ':')
      .replace(/ dash/gi, '-')
      .replace(/ slash/gi, '/')
      .replace(/ new line/gi, '\n');

    // Append spoken text to respective field
    (this.prescription as any)[fieldId] +=
      (this.prescription as any)[fieldId]
        ? '\n' + transcript
        : transcript;
  };

  recognition.onerror = (event: any) => {
    console.error('Speech recognition error:', event.error);
    this.stopRecording();
  };

  recognition.onend = () => {
    if (this.isRecording) {
      console.log('Recognition ended unexpectedly, restarting...');
      recognition.start();
    }
  };
}

// 🛑 Stop voice dictation
stopRecording() {
  if (this.recognition) {
    this.recognition.onend = null;
    this.recognition.stop();
    this.recognition = null;
  }
  this.isRecording = false;
  this.activeField = '';
}



}

// Patient name, primary_contact, email, dob